import { createContext } from 'react';

export const PermissionContext = createContext([]);
export const extractPrivileges = (userPermissionsBasedOnClinic,userRole,clinicId)=>{
    let privileges = [],permissions={},permissionsLoaded=false;
    if (userRole && userRole[clinicId] && userPermissionsBasedOnClinic[clinicId]) {
        permissionsLoaded = true;
        userRole[clinicId].forEach(role => {
        permissions = userPermissionsBasedOnClinic[clinicId][role] || [];
        const cPriv = Array.isArray(permissions)?permissions:[...(permissions["READ"] || []),...(permissions["WRITE"] || [])]
        privileges = [...privileges,...cPriv];
      });
    }
    return {privileges,permissionsLoaded};
}  